import type { IHeartBeatFetcher } from "../../network/fetchers/HeartBeatFetcher";
import type { ICurrentWindowStore } from "../window/ICurrentWindowStore";
import { fireAndForget } from "../../util/async/fireAndForget";
import type { ISessionStore } from "../session/SessionStore";

export interface IHeartBeatStore {
	start(): void;
	stop(): void;
}

export class HeartBeatStore implements IHeartBeatStore {
	private readonly pulseIntervalTimeout: number = 2 * 1000 * 60; //2 minutes
	private pulseInterval: number | null = null;

	constructor(
		private readonly heartBeatFetcher: IHeartBeatFetcher,
		private readonly currentWindowStore: ICurrentWindowStore,
		private readonly sessionStore: ISessionStore,
	) {}

	start(): void {
		const { heartBeatFetcher: heart, currentWindowStore, sessionStore } = this;
		const { currentWindow } = currentWindowStore;
		const { currentUser } = sessionStore;

		if (!currentUser) return;

		this.pulseInterval = currentWindow.setInterval(() => {
			fireAndForget(heart.pulse());
		}, this.pulseIntervalTimeout);
	}

	stop(): void {
		if (this.pulseInterval != null) {
			clearInterval(this.pulseInterval);
			this.pulseInterval = null;
		}
	}
}
